/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import getPath from '../assets/routes/paths';
import defaultTestimonials from '../services/data/testimonials';
import getLanguage from '../services/helpers';

function MainFooter({ translate }) {
  const language = getLanguage();

  const [testimonials, setTestimonials] = useState(null);

  useEffect(() => {
    if (defaultTestimonials[language]) {
      setTestimonials(shuffle(defaultTestimonials[language]).slice(0, 3));
    }
  }, [language]);

  const shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  return (
    <>
      <footer className="footer footer-big">
        <Container>
          <Row>
            <Col>
              <Row>
                <Col xs="6" md="3">
                  <h6 className="bold mt-4 mb-2 text-uppercase">
                    <Translate id="footer.get-started" />
                  </h6>
                  <div className="links">
                    <ul>
                      <li>
                        <Link to={getPath(language, 'HowItWorks')} className="not-default">
                          <Translate id="navbar.card.title" />
                        </Link>
                      </li>
                      <li>
                        <Link to={getPath(language, 'Plus')} className="not-default">
                          <Translate id="navbar.plus" />
                        </Link>
                      </li>
                      {['sv'].includes(language) && (
                        <li>
                          <Link to={getPath(language, 'Events')} className="not-default">
                            <Translate id="navbar.events.title" />
                          </Link>
                        </li>
                      )}
                      {['sv'].includes(language) && (
                        <li>
                          <Link to={getPath(language, 'Deals')} className="not-default">
                            <Translate id="navbar.more" />
                          </Link>
                        </li>
                      )}
                      <li>
                        <a href={'https://www.merch.golfamore.com/'} target="_blank" rel="noreferrer" className="not-default">
                          <Translate id="navbar.merch" />
                        </a>
                      </li>
                      <li>
                        <Link to={getPath(language, 'About')} className="not-default">
                          <Translate id="navbar.about" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col xs="6" md="3">
                  {/* <div className="links" style={{ paddingTop: '50px' }}> */}
                  <div className="links">
                    <h6 className="bold mt-4 mb-2 text-uppercase">
                      <Translate id="footer.good-to-know" />
                    </h6>
                    <ul>
                      <li className="text-uppercase">
                        <Link to={getPath(language, 'Faq')} className="not-default">
                          <Translate id="default.faq" />
                        </Link>
                      </li>
                      <li>
                        <Link to={getPath(language, 'Contact')} className="not-default">
                          <Translate id="default.contact-us" />
                        </Link>
                      </li>
                      {false && (
                        <li>
                          <Link to={getPath(language, 'SeasonOpen')} className="not-default">
                            <Translate id="navbar.season" />
                          </Link>
                        </li>
                      )}
                      {['sv', 'dk', 'no', 'de', 'en'].includes(language) && (
                        <li>
                          <Link to={getPath(language, 'News')} className="not-default">
                            <Translate id="navbar.news" />
                          </Link>
                        </li>
                      )}
                      {['sv', 'dk', 'no', 'en', 'de'].includes(language) && (
                        <li>
                          <Link to={getPath(language, 'CustomerClub')} className="not-default">
                            <Translate id="navbar.club19" />
                          </Link>
                        </li>
                      )}
                      {language === 'sv' && (
                        <li>
                          <a href="https://www.mynewsdesk.com/se/golfhaftet/" className="not-default" target="_blank" rel="noreferrer">
                            <Translate id="default.press" />
                          </a>
                        </li>
                      )}
                      {['sv', 'dk', 'no', 'fi'].includes(language) && (
                        <li>
                          <Link to={getPath(language, 'Retailers')} className="not-default">
                            <Translate id="navbar.retailers" />
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </Col>
                <Col md="3" xs="6">
                  <h6 className="bold mt-4 mb-2 text-uppercase">
                    <Translate id="footer.social-media.title" />
                  </h6>
                  <div className="links">
                    <ul>
                      <li>
                        <a
                          href="https://www.facebook.com/Golfamore/"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Facebook"
                          className="not-default"
                        >
                          <Translate id="footer.social-media.facebook" />
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.instagram.com/golfamore/"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Instagram"
                          className="not-default"
                        >
                          <Translate id="footer.social-media.instagram" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://youtube.com/@golfamore"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="YouTube"
                          className="not-default"
                        >
                          <Translate id="footer.social-media.youtube" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col md="3" xs="6">
                  <h6 className="bold mt-4 mb-2 text-uppercase">
                    <Translate id="footer.legal" />
                  </h6>
                  <div className="links">
                    <ul>
                      {language !== 'de' && (
                        <>
                          <li>
                            <Link to={getPath(language, 'Privacy')} className="not-default">
                              <Translate id="default.privacy-policy" />
                            </Link>
                          </li>
                          <li>
                            <Link to={getPath(language, 'Terms')} className="not-default">
                              <Translate id="default.terms" />
                            </Link>
                          </li>
                          <li>
                            <Link to={getPath(language, 'Cookies')} className="not-default">
                              <Translate id="default.cookies" />
                            </Link>
                          </li>
                          <li>
                            <Link to={getPath(language, 'RegretOrder')} className="not-default">
                              <Translate id="regret-order.link-title" />
                            </Link>
                          </li>
                        </>
                      )}
                      {language === 'de' && (
                        <>
                          <li>
                            <Link to="/de/agb" className="not-default">
                              AGB & Kundeninfo
                            </Link>
                          </li>
                          <li>
                            <Link to="/de/widerrufsbelehrung" className="not-default">
                              Widerrufsbelehrung
                            </Link>
                          </li>
                          <li>
                            <Link to="/de/widerruf" className="not-default">
                              <Translate id="regret-order.link-title" />
                            </Link>
                          </li>
                          <li>
                            <Link to="/de/datenschutzerklarung" className="not-default">
                              Datenschutz
                            </Link>
                          </li>
                          <li>
                            <Link to="/de/impressum" className="not-default">
                              Impressum
                            </Link>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col xs={12} className="text-center">
              <h6 className="bold mb-4 text-uppercase">
                <Translate id="footer.secure-payments" />
              </h6>
              <div className="d-flex align-items-center justify-content-center flex-wrap" style={{ gap: '10px' }}>
                <img src="/react-assets/img/kustom-logo-badge.png" alt="Kustom" style={{ height: '40px' }} />
                <img src="/react-assets/img/klarna-logo-badge.png" alt="Klarna" style={{ height: '80px' }} />

                {language === 'de' && (
                  <div className="badge">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" viewBox="0 0 338.667 89.785">
                      <g transform="translate(936.898 -21.779)">
                        <path
                          clipPath="none"
                          d="M-828.604 39.734c-.697 0-1.289.506-1.398 1.195l-8.068 51.165a1.31 1.31 0 0 0 1.294 1.513h9.568c.696 0 1.289-.507 1.398-1.195l2.37-15.025c.108-.688.701-1.195 1.398-1.195h8.699c10.164 0 18.792-7.416 20.368-17.465 1.589-10.134-6.328-18.971-17.549-18.993zm9.301 11.422h6.96c5.73 0 7.596 3.381 7.006 7.12-.59 3.747-3.488 6.507-9.031 6.507h-7.084zm45.788 3.478c-2.416.009-5.196.504-8.317 1.804-7.159 2.984-10.597 9.151-12.057 13.647 0 0-4.647 13.717 5.852 21.253 0 0 9.737 7.255 20.698-.447l-.189 1.203a1.31 1.31 0 0 0 1.292 1.513h9.083c.697 0 1.289-.507 1.398-1.195l5.525-35.038a1.31 1.31 0 0 0-1.292-1.515h-9.083c-.697 0-1.29.507-1.398 1.195l-.297 1.886s-3.967-4.333-11.216-4.306zm.297 11.067c1.043 0 1.997.144 2.853.419 3.919 1.258 6.141 5.023 5.498 9.104-.793 5.025-4.914 8.725-10.199 8.725-1.042 0-1.996-.143-2.853-.418-3.918-1.258-6.154-5.023-5.511-9.104.793-5.025 4.927-8.727 10.212-8.727z"
                          fill="#003087"
                        />
                        <path
                          clipPath="none"
                          d="M-697.804 39.734c-.697 0-1.289.506-1.398 1.195l-8.068 51.165a1.31 1.31 0 0 0 1.294 1.513h9.568c.696 0 1.289-.507 1.398-1.195l2.37-15.025c.108-.688.701-1.195 1.398-1.195h8.699c10.164 0 18.791-7.416 20.366-17.465 1.59-10.134-6.326-18.971-17.547-18.993zm9.301 11.422h6.96c5.73 0 7.596 3.381 7.006 7.12-.59 3.747-3.487 6.507-9.031 6.507h-7.084zm45.787 3.478c-2.416.009-5.196.504-8.317 1.804-7.159 2.984-10.597 9.151-12.057 13.647 0 0-4.645 13.717 5.854 21.253 0 0 9.735 7.255 20.697-.447l-.189 1.203a1.31 1.31 0 0 0 1.294 1.513h9.082c.697 0 1.289-.507 1.398-1.195l5.527-35.038a1.31 1.31 0 0 0-1.294-1.515h-9.083c-.697 0-1.29.507-1.398 1.195l-.297 1.886s-3.967-4.333-11.216-4.306zm.297 11.067c1.043 0 1.997.144 2.853.419 3.919 1.258 6.141 5.023 5.498 9.104-.793 5.025-4.914 8.725-10.199 8.725-1.042 0-1.996-.143-2.853-.418-3.918-1.258-6.154-5.023-5.511-9.104.793-5.025 4.927-8.727 10.212-8.727z"
                          fill="#0070e0"
                        />
                        <path
                          clipPath="none"
                          d="M-745.92 55.859c-.72 0-1.232.703-1.012 1.388l9.958 30.901-9.004 14.562c-.437.707.071 1.62.902 1.62h10.642a1.77 1.77 0 0 0 1.513-.854l27.811-46.007c.427-.707-.083-1.611-.909-1.611h-10.641a1.77 1.77 0 0 0-1.522.869l-10.947 18.482-5.557-18.345c-.181-.597-.732-1.006-1.355-1.006z"
                          fill="#003087"
                        />
                        <path
                          clipPath="none"
                          d="M-609.107 39.734c-.696 0-1.289.507-1.398 1.195l-8.07 51.163a1.31 1.31 0 0 0 1.294 1.515h9.568c.696 0 1.289-.507 1.398-1.195l8.068-51.165a1.31 1.31 0 0 0-1.292-1.513z"
                          fill="#0070e0"
                        />
                        <path
                          clipPath="none"
                          d="M-908.37 39.734a2.59 2.59 0 0 0-2.556 2.185l-4.247 26.936c.198-1.258 1.282-2.185 2.556-2.185h12.445c12.525 0 23.153-9.137 25.095-21.519a20.76 20.76 0 0 0 .245-2.793c-3.183-1.669-6.922-2.624-11.019-2.624z"
                          fill="#001c64"
                        />
                        <path
                          clipPath="none"
                          d="M-874.832 42.359a20.76 20.76 0 0 1-.245 2.793c-1.942 12.382-12.571 21.519-25.095 21.519h-12.445c-1.273 0-2.358.926-2.556 2.185l-3.905 24.752-2.446 15.528a2.1 2.1 0 0 0 2.075 2.43h13.508a2.59 2.59 0 0 0 2.556-2.185l3.558-22.567a2.59 2.59 0 0 1 2.558-2.185h7.953c12.525 0 23.153-9.137 25.095-21.519 1.379-8.788-3.047-16.784-10.611-20.75z"
                          fill="#0070e0"
                        />
                        <path
                          clipPath="none"
                          d="M-923.716 21.779c-1.273 0-2.358.926-2.556 2.183l-10.6 67.216c-.201 1.276.785 2.43 2.077 2.43h15.719l3.903-24.752 4.247-26.936a2.59 2.59 0 0 1 2.556-2.185h22.519c4.098 0 7.836.956 11.019 2.624.218-11.273-9.084-20.58-21.873-20.58z"
                          fill="#003087"
                        />
                      </g>
                    </svg>
                  </div>
                )}
              </div>
            </Col>
          </Row>
          {['en', 'sv', 'de', 'dk', 'no'].includes(language) && (
            <>
              <h6 className="bold mt-5 mb-4 text-center text-uppercase">{translate('default.testimonials')}</h6>
              <Row className="mt-3">
                {testimonials?.map((t) => (
                  <Col sm="4" key={t.id}>
                    <Card>
                      <CardBody>
                        <p className="text-italic" style={{ fontSize: '14px' }}>
                          {t.text}
                        </p>
                        <span className="bold">{t.name}</span>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </>
          )}
          <Row className="mt-4">
            <Col xs="12" sm="4">
              <img src="/react-assets/img/swgt-official-partner.png" className="img-fluid" alt="Swedish Golf team official partner" />
            </Col>
            <Col xs="12" sm="4" className="d-flex justify-content-center align-items-center pt-4">
              <img
                src="/react-assets/img/dgu-partner.png"
                className="img-fluid"
                style={{ maxWidth: '100%' }}
                alt="Danish Golf Union partner"
              />
            </Col>
            <Col xs="12" sm="4" className="d-flex justify-content-center align-items-center pt-4">
              <img src="/react-assets/img/ecco-golf-logo.png" className="img-fluid" style={{ maxWidth: '100%' }} alt="Ecco Golf" />
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-4">
              <hr />
              <div className="copyright">
                <div className="">© Golfhäftet i Sverige AB, all rights reserved</div>
                <small>{process.env.REACT_APP_VERSION}</small>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default withLocalize(MainFooter);
